export default {
  templates: [],
  editTemplate: null,
  searchedTemplates: [],
  templatesPageData: [],
  templatesDayShiftCount: {},
};
